import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import LoginModal from './LoginModal';
import './CTA.css';

const CTA = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  return (
    <section className="cta-section" ref={ref}>
      <div className="cta-background">
        <div className="cta-gradient-orb"></div>
      </div>
      
      <motion.div
        className="cta-content"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1 }}
      >
        <motion.div
          className="cta-badge"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Ограниченное предложение
        </motion.div>

        <motion.h2
          className="cta-title-main"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Запустите пилотный проект
        </motion.h2>
        
        <motion.p
          className="cta-subtitle-main"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Протестируйте аватара в вашей компании на специальных условиях. 
          Обсудим задачу и подготовим решение под ваш кейс.
        </motion.p>

        <motion.div
          className="cta-buttons"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <a href="https://t.me/justdisplay" target="_blank" rel="noopener noreferrer" className="cta-primary">
            Обсудить пилот
          </a>
        </motion.div>

        <motion.p
          className="cta-note"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          Или напишите на <a href="mailto:gleb@performerai.ru">gleb@performerai.ru</a>
        </motion.p>
      </motion.div>
      
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </section>
  );
};

export default CTA;
